import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { useSelector, useDispatch } from "react-redux";

import { ACTIONS as UI_ACTIONS } from "../../redux/ui";
import { ACTIONS as MAIN_ACTIONS } from "../../redux/main";
import Alert from "../alert";

const Container = ({ children }) => {
  const dispatch = useDispatch();
  const alertState = useSelector((state) => state.ui.alert);

  //
  const initReduxState = () => {
    dispatch(MAIN_ACTIONS.init());
  };

  const onAlertCloseHandler = () => {
    dispatch(UI_ACTIONS.closeAlert());
  };

  useEffect(() => {}, []);

  return (
    <>
      <div className="container">{children}</div>
      {alertState?.message &&
        createPortal(
          <Alert {...alertState} onClose={onAlertCloseHandler} />,
          document.body
        )}
    </>
  );
};

export default Container;
